import React, { useState, useEffect } from "react";
import "./ImageViewer.css"; // Add CSS for styling

const ImageViewer = ({ imageUrl, finishedTalking, setFinishedTalking, onClose }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openedAtRef = React.useRef(null);

  const openModal = () => {
    openedAtRef.current = Date.now();
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    openedAtRef.current = null;
    if (onClose) onClose();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      openModal(); // Open modal after 1 second
    }, 1000);

    return () => clearTimeout(timer); // Cleanup timeout on unmount
  }, [imageUrl]);

  // Auto-close once avatar finishes speaking, but keep modal open for at least 3 seconds
  useEffect(() => {
    if (finishedTalking) {
      const elapsed = openedAtRef.current ? Date.now() - openedAtRef.current : 3000;
      const delay = Math.max(0, 3000 - elapsed);
      const timer = setTimeout(() => {
        closeModal();
        if (setFinishedTalking) setFinishedTalking(false);
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [finishedTalking]);

  return (
    <div className="image-viewer">
      {/* Render the image */}
      <img
        src={imageUrl}
        alt="Thumbnail"
        className="thumbnail"
        onClick={openModal}
      />
      <button className="expand-button" onClick={openModal}>
        Expand
      </button>

      {/* Modal for zoomed-in image */}
      <div className={`modal-overlay ${isModalOpen ? "open" : "closed"}`} onClick={closeModal}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <img src={imageUrl} alt="Zoomed" className="zoomed-image" />
          <button className="close-button" onClick={closeModal}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageViewer;